import React  from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
// import { useMediaQuery, Hidden } from '@material-ui/core';

import { Informed, Invest, FinancialModel } from 'pages';
import Feedback from 'pages/Investor/Feedback';
import Logout from 'pages/Investor/Logout';
import Discuss from 'pages/Investor/Discuss';
import { Sidebar } from './components';
import MinimalStyle from './MinimalStyle';

const useStyles = makeStyles(MinimalStyle);

const Minimal = (props) => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  // const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
  //   defaultMatches: true
  // });

  // const [openSidebar, setOpenSidebar] = useState(false);

  // const handleSidebarOpen = () => {
  //   setOpenSidebar(true);
  // };

  // const handleSidebarClose = () => {
  //   setOpenSidebar(false);
  // };

  // const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div className={classes.wrapper}>
      <Sidebar logoText="Drivee" variant="persistent" />
      <div className={classes.mainPanel}>
        <div className={classes.content}>
          <div className={classes.container}>
            <Switch>
              <Route component={Informed} exact path="/panel" />
              <Route component={Feedback} exact path="/newfeedback" />
              <Route component={FinancialModel} exact path="/financialmodel" />
              <Route component={Invest} exact path="/invest" />
              <Route component={Logout} exact path="/logout" />
              <Route component={Discuss} exact path="/discuss" />
            </Switch>
          </div>
        </div>
      </div>
      {/* <Topbar items={MenuItems} onSidebarOpen={onSidebarOpen} /> */}
      {/* <main className={classes.content}>{children}</main> */}
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node
};

export default Minimal;
